export var UPLOAD_STATUS;
(function (UPLOAD_STATUS) {
    UPLOAD_STATUS["FAILED"] = "Failed";
    UPLOAD_STATUS["IN_PROGRESS"] = "In Progress";
    UPLOAD_STATUS["PENDING"] = "Pending";
    UPLOAD_STATUS["SUCCESSFUL"] = "Successful";
    UPLOAD_STATUS["GENERATING"] = "Generating";
})(UPLOAD_STATUS || (UPLOAD_STATUS = {}));
//# sourceMappingURL=uploadHistoryModel.js.map